import React, { useEffect, useState } from 'react';
import './gyogik.css';
import { BrowserRouter, Routes, Route, Link,Navigate } from "react-router-dom"



function Tell() {
  const [isVisible, setIsVisible] = useState(false); // 초기 상태는 '숨김'으로 설정합니다.

  const menuItems = {
    '총장실': [
      // { name: '교무처 전체', code: 's1' },
       { name: '총장실', code: '14' },
      
     ],
    '교무처': [
     // { name: '교무처 전체', code: '15' },
      { name: '교무과', code: '22' },
      { name: '학생운영과', code: '23' },
    ],
    '학생처': [
     // { name: '학생처 전체', code: '16' },
      { name: '학생지원팀', code: '24' },
      { name: '장학팀', code: '25' },
    ],
    '기획처': [
    //  { name: '기획처 전체', code: '17' },
      { name: '기획평가과', code: '26' },
      { name: '대외협력과', code: '27' },
    ],

    '사무국': [
      //{ name: '사무국 전체', code: '18' },
      { name: '총무과', code: '28' },
      { name: '재무과', code: '29' },
      { name: '시설과', code: '30' },
    ],
    '산학협력단': [
      // { name: '산학협력단 전체', code: '19' },
      { name: '창업보육센터', code: '31' },
      { name: '강원임베디드소프트웨어연구센터', code: '32' },
      { name: '해양생물연구교육센터', code: '33' },
      { name: '중소기업산학협력센터', code: '34' },
      { name: '파인세라믹지역기술혁신센터', code: '35' },
      { name: '해양센서네트워크시스템기술연구센터', code: '36' },
      { name: '동해안해양생물자원연구센터', code: '37' },
      { name: '수충부및토석류방재기술연구단', code: '38' },
      { name: '서울어코드활성화사업단', code: '39' },
      { name: '강릉시어린이급식관리자지원센터', code: '40' },
      { name: '강원씨그랜트센터', code: '41' },
      { name: '산학협력선도대학사업단', code: '42' },
    ],
    '산학협력단 원주분관': [
      { name: '산학협력단 원주분관', code: '20' },
    ],
    '입학본부': [
      //{ name: '입학본부 전체', code: '21' },
      { name: '입학과', code: '43' },
      { name: '입학전형실', code: '44' },
      
    ],
    '인문대학': [
      //{ name: '인문대학 전체', code: '45' },
      { name: '국어국문학과', code: '46' },
      { name: '영어영문학과', code: '74' },
      { name: '독어독문학과', code: '75' },
      { name: '중어중문학과', code: '76' },
      { name: '일본학과', code: '77' },
      { name: '철학과', code: '78' },
      { name: '사학과', code: '79' },
      { name: '교직과정', code: '80' },
    ], 
    '사회과학대학': [
       //{ name: '사회과학대학 전체', code: '66' },
       { name: '경제학과', code: '81' },
       { name: '경영학과', code: '82' },
       { name: '회계학과', code: '83' },
       { name: '무역학과', code: '84' },
       { name: '도시계획부동산학과', code: '85' },
       { name: '법학과', code: '86' },
       { name: '관광경영학과', code: '87' },
       { name: '자치행정학과', code: '88' },
       { name: '국제통상학과', code: '89' },
     ],
     '자연과학대학 전체': [
      // { name: '자연과학대학 전체', code: '67' },
       { name: '수학과', code: '90' },
       { name: '정보통계학과', code: '91' },
       { name: '물리학과', code: '92' },
       { name: '생물학과', code: '93' },
       { name: '대기환경과학과', code: '94' },
       { name: '화학신소재학과', code: '95' },    
     ],
     '생명과학대학': [
       { name: '생명과학대학 전체', code: '68' },
       { name: '식품영양학과', code: '96' },
       { name: '식품영양학과', code: '97' },
       { name: '해양식품공학과', code: '98' },
       { name: '해양자원육성학과', code: '99' },
       { name: '해양생물공학과', code: '100' },
       { name: '해양분자생명공학과', code: '101' },
       { name: '식물생명과학과', code: '102' },
       { name: '환경조경학과', code: '103' },
     ],
     '공과대학': [
      { name: '공과대학 전체', code: '69' },
      { name: '전자공학과', code: '104' },
      { name: '산업정보경영공학과', code: '105' },
      { name: '세라믹신소재공학과', code: '106' },
      { name: '신소재금속공학과', code: '107' },
      { name: '토목공학과', code: '108' },
      { name: '생명화학공학과', code: '109' },
    ],
    '치과대학': [
      { name: '치과대학 전체', code: '70' },
      { name: '치의학과', code: '110' },
      { name: '치위생학과', code: '111' },
      { name: '치의예과', code: '112' },
    ],
    '보건복지대학': [
      { name: '보건복지대학 전체', code: '71' },
      { name: '간호학과', code: '113' },
      { name: '유아교육과', code: '114' },
      { name: '다문화학과', code: '115' },
      { name: '복지학과', code: '116' },
    
    ],
    '예술체육대학': [
      { name: '예술체육대학 전체', code: '72' },
      { name: '미술학과', code: '117' },
      { name: '공예조형디자인 학과', code: '118' },
      { name: '체육학과', code: '119' },
    
    ],
    '과학기술대학': [
      { name: '과학기술대학 전체', code: '73' },
      { name: '컴퓨터공학과', code: '120' },
      { name: '멀티미디어공학과', code: '121' },
      { name: '정보기술공학과', code: '122' },
      { name: '전기공학과', code: '123' },
      { name: '정보통신공학과', code: '124' },
      { name: '기계자동차공학부 정밀기계공학전공', code: '125' },
      { name: '기계자동차공학부 기계의용공학전공', code: '126' },
      { name: '기계자동차공학부 자동차공학전공', code: '127' },
      { name: '산업경영공학과', code: '128' },
    
    ],
   
};
console.log(menuItems.name);
//const [visibleMenu, setVisibleMenu] = useState({});
 // visibleMenu 상태를 객체로 초기화
 const [visibleMenu, setVisibleMenu] = useState(
  Object.keys(menuItems).reduce((acc, menuName) => {
    acc[menuName] = false;
    return acc;
  }, {})
);  
/*
const toggleMenu = (menuName) => {
    setVisibleMenu({
        ...visibleMenu,
        [menuName]: !visibleMenu[menuName]
    });
};*/
const toggleMenu = (menuName) => {
  // 현재 상태를 기반으로 menuName에 해당하는 값을 토글
  setVisibleMenu((prevVisibleMenu) => ({
    ...prevVisibleMenu,
    [menuName]: !prevVisibleMenu[menuName],
  }));
};
  const [data, setData] = useState([]);
  const [gyogik, setgyogik] = useState([]);
  useEffect(() => {
    const url3 = `/backend/gyogik`;
    fetch(url3)
    .then(response => response.json())
    .then(data => {
      // 서버로부터 받은 데이터 처리
      console.log(data);
      setgyogik(data);
      console.log(Array.isArray(data));
    })
  }, []);

  return (
    <div className="container">
      <div className="page">
         <div className="AppG App-headerG gnb_bsG">
         <header style={{width: "100%"}}>
          <div className="gnb_1">
          <button onClick={() => window.history.back()} class="arrow-button">
  <span class="arrow-icon"></span>
</button>
                <span className="title">전화번호 안내</span>
                <div className="gnb_1_1">
                    <Link className="gnb_qrG" to="/qr">
                        <div className="gnb_qrG"></div>
                    </Link>
                    <a className="gnb_notiG" href="/"></a>
                </div>
          </div>
        </header>
          <div className="body">
            
          <div>
          {Object.keys(menuItems).map((menuName) => (
        <div key={menuName}>
          <div className="buseo" onClick={() => toggleMenu(menuName)}>
            {/*<a>GWNU</a>*/}
            <span>{menuName}</span>
          </div>
          {visibleMenu[menuName] && menuItems[menuName].map((menuItem) => (
            <Link style={{text_decoration:"none"}} to={`/Tell_info/${menuItem.code}/${menuItem.name}`} key={menuItem.code}>
              <div className="detail">
                <span>{menuItem.name}</span>
              </div>
            </Link>
          ))}
        </div>
      ))}
        </div>

          </div>
	      </div>
	    </div>
	  </div>
  );
}

export default Tell;